import {
  useCoveragePriceCalculations,
  useFormState,
} from "Store/priceCalculation/priceCalculationHooks";

import { WrapLgMarginBottom } from "App/global-style";
import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { getSelectedCoverage } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.helpers";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { AkaStudentCoverage } from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";
import { useFormikContext } from "formik";
import React from "react";
import { AkaStudentProductIntroFormValues } from "../ProductIntro/akaStudentProductIntroInterfaces";
import { AKA_STUDENT_ABOUT_YOU_STEP } from "../akaStudentSteps";
import { AkaStudentProductPriceFormValues } from "./akaStudentProductPriceInterfaces";

interface Props {
  coverageType: AkaStudentCoverage;
  isPriceLoading: boolean;
}

const { akastudent: coverageCardTextComponents } =
  getCollectionOfDittoComponents(TextComponentNameLevel1.COVERAGE_CARD);

export const AkaStudentCoverages = ({
  coverageType,
  isPriceLoading,
}: Props): React.ReactElement => {
  const coverages = useCoveragePriceCalculations();
  const selectedCoverage = getSelectedCoverage(coverageType, coverages);
  const formProps = useFormikContext<AkaStudentProductPriceFormValues>();
  const formProductIntro = useFormState(
    AKA_STUDENT_ABOUT_YOU_STEP.id,
  ) as Required<AkaStudentProductIntroFormValues>;

  return (
    <WrapLgMarginBottom>
      {selectedCoverage && (
        <DittoCoverageCard
          fieldName="coverage"
          product={ProductBackendName.AKA_STUDENT}
          coverage={selectedCoverage[0]}
          textComponents={coverageCardTextComponents}
          prices={selectedCoverage[1].prices}
          priceIsLoading={isPriceLoading}
          disabledCoverageDesc
          hideRadioButton
          customDescription={formProductIntro.country}
        />
      )}

      {isDefined(formProps.values.coverage) && (
        <CurrentPriceMessage
          productBackendName={ProductBackendName.AKA_STUDENT}
          coverages={coverages}
          selectedPrices={[
            {
              selectedCoverage: formProps.values.coverage,
              selectedDeductible: undefined,
              defaultDeductible: undefined,
            },
          ]}
        />
      )}
    </WrapLgMarginBottom>
  );
};
